import { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WelcomeOverlay from "./components/WelcomeOverlay";
import Navbar from "./components/Navbar";
import CustomCursor from "./components/CustomCursor";
import HeroSection from "./components/sections/HeroSection";
import StatementSection from "./components/sections/StatementSection";
import WorkSection from "./components/sections/WorkSection";
import AboutSection from "./components/sections/AboutSection";
import ServicesSection from "./components/sections/ServicesSection";
import FilmSection from "./components/sections/FilmSection";
import PhilosophySection from "./components/sections/PhilosophySection";
import TestimonialsSection from "./components/sections/TestimonialsSection";
import ContactSection from "./components/sections/ContactSection";
import Footer from "./components/Footer";
import useScrollReveal from "./hooks/useScrollReveal";
import { Toaster } from "./components/ui/toaster";

const Site = () => {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (entered) {
      document.body.style.overflow = "auto";
    } else {
      document.body.style.overflow = "hidden";
    }
  }, [entered]);

  useScrollReveal(entered);

  return (
    <div className="odda-root">
      {!entered && <WelcomeOverlay onEnter={() => setEntered(true)} />}
      <Navbar visible={entered} onReset={() => { window.scrollTo({ top: 0, behavior: "instant" }); setEntered(false); }} />
      <main id="top">
        <HeroSection />
        <StatementSection />
        <WorkSection />
        <AboutSection />
        <ServicesSection />
        <FilmSection />
        <PhilosophySection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
      <CustomCursor />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Site />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
